import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { client } from 'utils/api-client';

export default function useCloseBanner(): UseMutationResult<AxiosResponse<void>, AxiosError<void>, string> {
  const queryClient = useQueryClient();

  const closeBanner = useCallback((bannerId: string): Promise<AxiosResponse<void>> => {
    return client.post(`banners/${bannerId}/close/`);
  }, []);

  return useMutation(closeBanner, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['banners'],
      });
    },
  });
}
